export default __webpack_public_path__ + "static/media/boat.9ba6d722.png";